module.exports = __webpack_public_path__ + "static/icon-8ff095c0454fb43e2123c78b83710135.png";